import { defineStore } from "pinia";
import api from "@/services/api";

export const useConfigStore = defineStore("config", {
    state: () => ({
        configs: [],
        disabledModules: [],
        loading: false,
        fetchedAt: 0,
        ttl: 1 * 60_000
    }),

    persist: true,

    actions: {
        async fetchConfig(force = false) {
            const now = Date.now();

            const hasData = this.configs && (Array.isArray(this.configs) ? this.configs.length > 0 : Object.keys(this.configs).length > 0);
            if (!force && hasData && now - this.fetchedAt < this.ttl) return;

            this.fetchedAt = now;

            try {
                const res = await api.get('/config');
                this.configs = res.data.data;
                this.disabledModules = res.data.data?.disabled_modules || [];
            } catch (err) {
                console.error("Failed to fetch config:", err);
            }
        },
        isDisabled(slugOrModule) {
            if (!this.disabledModules || !Array.isArray(this.disabledModules)) return false;
            if (Array.isArray(slugOrModule)) {
                return slugOrModule.some(s => this.disabledModules.includes(s));
            }
            return this.disabledModules.includes(slugOrModule);
        },
        reset() {
            this.configs = [];
            this.disabledModules = [];
        }
    },
});